import { useState } from 'react'
import { Icon } from './Icon'
import { ContactForm } from './ContactForm'
import { linkWhatsApp } from '../config'

const PERGUNTAS = [
  { q: 'A Skyenex garante aumento nas vendas?', a: 'Não prometemos números. Estruturamos sua operação com as melhores práticas de cada plataforma e acompanhamos os indicadores. O resultado vem da consistência da operação somada ao nosso trabalho.' },
  { q: 'Vocês trabalham apenas com iFood e 99 Food?', a: 'São as duas plataformas que estruturamos e gerimos hoje. Além delas, entregamos canais próprios: cardápio digital, WhatsApp, mesas, balcão e totem de autoatendimento.' },
  { q: 'Já tenho minha loja configurada. Posso contratar somente a gestão?', a: 'Pode. Nesse caso fazemos um diagnóstico do que já existe, ajustamos o que for necessário e seguimos com o acompanhamento contínuo.' },
  { q: 'Posso contratar apenas um produto da Skyenex?', a: 'Sim. Os produtos do ecossistema podem ser contratados separadamente, de acordo com a necessidade da sua operação.' },
  { q: 'Vocês atendem restaurantes que estão começando?', a: 'Sim. O Plano Pro foi desenhado exatamente para quem está começando, com cadastro, configuração e suporte para a loja entrar no ar bem estruturada.' },
  { q: 'Como sei qual solução é melhor para meu restaurante?', a: 'Converse com um especialista. Entendemos seu momento, seu cardápio e seus objetivos antes de recomendar qualquer plano.' },
]

export function Contact() {
  // Sanfona: uma resposta aberta por vez. Guardar o indice em vez de um
  // booleano por item e o que garante isso sem sincronizar nada.
  const [aberta, setAberta] = useState<number | null>(null)

  return (
    <section className="contact" id="contato">
      <div className="shell contact__grid">

        <div className="form-card" data-reveal="up">
          <div className="form-card__side" aria-hidden="true" />
          <div className="form-card__body">
            <h2>Vamos conversar?</h2>
            <p className="form-card__lead">
              Preencha os dados e nossa equipe entrará em contato o mais breve possível.
            </p>
            <ContactForm />
          </div>
        </div>

        <div className="faq-block">
          <p className="eyebrow eyebrow--dark" data-reveal="up"><i />Dúvidas frequentes</p>
          <h2 className="h2" data-reveal="mask">Perguntas<br />mais <span className="accent">comuns.</span></h2>

          <ul className="faq" data-reveal="up" data-delay="120">
            {PERGUNTAS.map((p, i) => (
              <li className={`faq__item${aberta === i ? ' is-open' : ''}`} key={p.q}>
                <button
                  type="button"
                  className="faq__q"
                  aria-expanded={aberta === i}
                  onClick={() => setAberta(aberta === i ? null : i)}
                >
                  {p.q}
                </button>
                <div className="faq__a"><p>{p.a}</p></div>
              </li>
            ))}
          </ul>
        </div>

        <aside className="doubt" data-reveal="up" data-delay="180">
          <span className="doubt__ico"><Icon name="chat" /></span>
          <h3>Ainda tem<br />dúvidas?</h3>
          <p>Fale com a gente pelo WhatsApp.</p>
          <a href={linkWhatsApp()} className="btn btn--light btn--block">Abrir WhatsApp</a>
          <span className="script script--6">Nossa equipe<br />está à disposição!</span>
        </aside>

      </div>
    </section>
  )
}
